import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  createFolderApi,
  deleteFileAndFolderAPi,
  getChildFoldersApi,
  hideFileFoldersApi,
  renameFileApi,
  renameFolderApi,
  uploadFileInDriveApi,
} from "../../apis/fileManagerApis";
import {
  AddFolderTypesPayload,
  DeleteFileFolderPayloadType,
  GetChildFoldersTypePayload,
  HideFileFolderPayloadType,
  RenameFileTypePayload,
  RenameFolderTypePayload,
  UploadFileTypesPayload,
} from "../../commonTypes/fileManagerTypes";

export const createFolderAction = createAsyncThunk(
  "fileManager/creatFolder",
  async (data: AddFolderTypesPayload) => {
    const response = await createFolderApi(data);
    return response.data;
  }
);

export const uploadFileInDriveAction = createAsyncThunk(
  "fileManager/uploadFile",
  async (data: UploadFileTypesPayload) => {
    const response = await uploadFileInDriveApi(data);
    return response.data;
  }
);

export const getChildFoldersAction = createAsyncThunk(
  "fileManager/getChildFolders",
  async (data: GetChildFoldersTypePayload) => {
    const response = await getChildFoldersApi(data);
    return response.data;
  }
);

export const renameFolderAction = createAsyncThunk(
  "fileManager/renameFolder",
  async (data: RenameFolderTypePayload) => {
    const response = await renameFolderApi(data);
    return response.data;
  }
);
export const renameFileAction = createAsyncThunk(
  "fileManager/renameFile",
  async (data: RenameFileTypePayload) => {
    const response = await renameFileApi(data);
    return response.data;
  }
);

export const deleteFileAndFolderAction = createAsyncThunk(
  "fileManager/delete",
  async (data: DeleteFileFolderPayloadType) => {
    const response = await deleteFileAndFolderAPi(data);
    return response.data;
  }
);
export const hideFileFolderAction = createAsyncThunk(
  "fileManager/hideFile",
  async (data: HideFileFolderPayloadType) => {
    const response = await hideFileFoldersApi(data);
    return response.data;
  }
);
